import Brand from '../Component/Image/Brend.JPG';
import MobImg from '../Component/Image/mobimg.jpg'

export const About = ( ) => {
    return (
        <section id="about">
            <div className="container">
                <div className="row align-items-center padding-115px">
                    <div className="col-lg-5">
                        <img src={Brand}  alt="Oner_photo"/>
                        
                    </div>
                    <div className='text-wd-bl'>
                    <img src={MobImg}  alt="moblricon" className='moble_img'/>
                        <h6>About us</h6>
                        <h2>About Barber Malek</h2>
                        <p>An experienced and dedicated stylist and barber, I have been passionately providing excellent customer service for over 20 years. I possess skilled formal training and interpersonal abilities that enable me to work with clients from various countries, including Canada.</p>
                        <p>I am well-versed in popular techniques such as fades, line-ups, and straight blade shaves for men. As a versatile Barber and Hairdresser, I engage in thorough consultations with clients, analyzing their hair and desired styles.</p>
                        <p>At our establishment, we offer a wide range of popular treatments. These include classic straight blade shaves, threading techniques, as well as modern line-ups and undercuts.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}